import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, loading, token } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-background text-muted-foreground">
        <Loader2 className="animate-spin" size={28} />
      </div>
    );
  }
  if (!token || !user) return <Navigate to="/admin/login" replace />;
  return children;
}
